import React from "react";
import { useTranslation } from "react-i18next";
import { appDate } from "@/utils/appDateFormat";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogBody,
  DialogFooter,
} from "../../../components/ui/Dialog";
import Button from "../../../components/ui/Button";
import SafeMarkdown from "../../../components/terms/SafeMarkdown";
import {
  coerceKind,
  coerceTermsStatus,
  termsKindLabel,
  type PlatformTermsView,
} from "../../../api/General/PlatformTerms";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  record: PlatformTermsView | null;
}

const TermsPreviewDialog: React.FC<Props> = ({ open, onOpenChange, record }) => {
  const { t } = useTranslation();
  if (!record) return null;
  const kind = coerceKind(record.kind);
  const status = coerceTermsStatus(record.status);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="lg" className="flex flex-col max-h-[90vh]">
        <DialogHeader>
          <DialogTitle>{record.title || t(termsKindLabel(kind))}</DialogTitle>
          <DialogDescription className="mt-1">
            v{record.version}
            <span className="mx-1.5 opacity-40">·</span>
            <span className="text-[11px] uppercase tracking-wider">{t(status)}</span>
            {record.effectiveFrom && (
              <>
                <span className="mx-1.5 opacity-40">·</span>
                {t("Effective")} {appDate(record.effectiveFrom)}
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogBody className="flex-1 min-h-0 overflow-y-auto">
          <SafeMarkdown content={record.contentMarkdown || ""} />
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t("Close")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TermsPreviewDialog;
